import { Product } from '../../types';

export const PRODUCTS: Product[] = [
  {
    id: '1',
    slug: 'yugoslav-heritage-tshirt-bureaucratic-chic',
    docNo: 'YU-001',
    classification: 'tshirt',
    cost: 'products.visitStore',
    imageUrl: '/products/yugoslav-heritage-tshirt-bureaucratic-chic.jpg',
    imageAlt: 'Heritage T-Shirt for people Born in Yugoslavia featuring YU-001 bureaucratic design and brutalist typography',
    name: 'Heritage T-Shirt - Bureaucratic Chic',
    description: 'Yugoslav nostalgia t-shirt featuring authentic bureaucratic design elements and brutalist typography',
    longDescription: 'This Heritage T-Shirt embodies the essence of Yugoslav bureaucratic aesthetics with its bold typewriter fonts and official document styling. Made from premium cotton, it features the iconic YU-001 document number and celebrates the unique visual language of socialist-era institutions. Perfect for those who appreciate brutalist design and Yugoslav cultural heritage.',
    price: 22.90,
    currency: 'USD',
    availability: 'InStock',
    brand: 'Born in YU',
    sku: 'YU-001-TSHIRT',
    url: 'https://borninyu.com/product/yugoslav-heritage-tshirt-bureaucratic-chic',
    features: [
      'Authentic Yugoslav bureaucratic design',
      'Premium 100% cotton fabric',
      'Heavy typewriter font typography',
      'Official document YU-001 styling',
      'Unisex fit',
    ],
    materials: ['100% Premium Cotton', 'Screen-printed design', 'Tag-free comfort label'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: '2',
    slug: 'yugoslav-archive-tshirt-socialist-modernism',
    docNo: 'YU-002',
    classification: 'hoodie',
    cost: 'products.visitStore',
    imageUrl: '/products/yugoslav-archive-tshirt-socialist-modernism.jpg',
    imageAlt: 'Archive T-Shirt for people Born in Yugoslavia featuring YU-002 socialist modernist design and geometric stamps',
    name: 'Archive T-Shirt - Socialist Modernism',
    description: 'Yugoslav archive t-shirt combining brutalist aesthetics with modern comfort',
    longDescription: 'The Archive T-Shirt brings together the stark beauty of socialist modernism with contemporary comfort. Featuring the YU-002 document classification, this t-shirt showcases bold geometric stamps and utilitarian design philosophy that defined an era. Premium cotton construction ensures comfort while maintaining the authentic bureaucratic aesthetic.',
    price: 22.15,
    currency: 'USD',
    availability: 'InStock',
    brand: 'Born in YU',
    sku: 'YU-002-TSHIRT',
    url: 'https://borninyu.com/product/yugoslav-archive-tshirt-socialist-modernism',
    features: [
      'Socialist modernist design elements',
      'Premium cotton material',
      'YU-002 official document styling',
      'Bold geometric stamp graphics',
      'Comfortable fit',
      'Unisex design',
    ],
    materials: ['100% Premium Cotton', 'Screen-printed design', 'Tag-free comfort label'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: '3',
    slug: 'yugoslav-bureaucratic-tote-bag',
    docNo: 'YU-003',
    classification: 'totebag',
    cost: 'products.visitStore',
    imageUrl: '/products/yugoslav-bureaucratic-tote-bag.jpg',
    imageAlt: 'Bureaucratic Tote Bag for people Born in Yugoslavia featuring YU-003 government form aesthetic and official stamps',
    name: 'Bureaucratic Tote Bag - Functional Beauty',
    description: 'Yugoslav-inspired tote bag celebrating the utilitarian beauty of government forms and official stamps',
    longDescription: 'This Bureaucratic Tote Bag captures the utilitarian beauty that defined Yugoslav institutional design. Document YU-003 features authentic typewriter fonts and official classification stamps on a durable canvas construction. Spacious enough for daily use while celebrating the unique visual language of socialist-era bureaucracy.',
    price: 27.12,
    currency: 'USD',
    availability: 'InStock',
    brand: 'Born in YU',
    sku: 'YU-003-TOTE',
    url: 'https://borninyu.com/product/yugoslav-bureaucratic-tote-bag',
    features: [
      'Government form aesthetic',
      'Durable canvas construction',
      'YU-003 classification stamps',
      'Reinforced handles',
      'Large capacity',
      'Versatile everyday use',
    ],
    materials: ['Heavy-duty cotton canvas', 'Screen-printed graphics', 'Reinforced stitching'],
    sizes: ['One Size'],
  },
  {
    id: '4',
    slug: 'k67-modular-kiosk-poster-yugoslav-design',
    docNo: 'YU-004',
    classification: 'poster',
    cost: 'products.visitStore',
    imageUrl: '/products/k67-modular-kiosk-poster-yugoslav-design.jpg',
    imageAlt: 'K67 Modular Kiosk Poster celebrating Yugoslav design heritage - Born in Yugoslavia iconic architecture by Saša J. Mächtig',
    name: 'K67 Modular Kiosk Poster - Saša J. Mächtig',
    description: 'Iconic K67 modular kiosk system designed by Saša J. Mächtig - a Yugoslav design masterpiece from 1967',
    longDescription: 'Document YU-004 celebrates the legendary K67 modular kiosk system, designed in 1966 by Slovenian architect Saša J. Mächtig and patented in 1967. This revolutionary polyfibre-reinforced modular design became a global phenomenon, with 7,500 units produced from 1968-1999 across Yugoslavia and exported worldwide to Poland, Japan, New Zealand, Kenya, Iraq, the Soviet Union, and the United States. Featured in MoMA\'s permanent collection and the acclaimed "Toward a Concrete Utopia" exhibition, the K67 represents the pinnacle of Yugoslav industrial design - combining functionality, modularity, and socialist-era innovation. This museum-quality poster immortalizes one of the most successful modular architecture projects ever realized.',
    price: 16.98,
    currency: 'USD',
    availability: 'InStock',
    brand: 'Born in YU',
    sku: 'YU-004-POSTER',
    url: 'https://borninyu.com/product/k67-modular-kiosk-poster-yugoslav-design',
    features: [
      'Iconic K67 modular kiosk design by Saša J. Mächtig',
      'Featured in MoMA permanent collection',
      'Museum-quality archival print',
      'Revolutionary 1967 Yugoslav industrial design',
      'Modular architecture pioneer',
      'Ready to frame',
    ],
    materials: ['Premium matte paper', 'Archival-quality ink', 'Fade-resistant printing'],
    sizes: ['A3 (297 x 420 mm)', 'A2 (420 x 594 mm)'],
  },
  {
    id: '5',
    slug: 'boli-me-kurac-tshirt-yugoslav-expression',
    docNo: 'YU-005',
    classification: 'tshirt',
    cost: 'products.visitStore',
    imageUrl: '/products/boli-me-kurac-tshirt-yugoslav-expression.jpg',
    imageAlt: 'Boli Me Kurac T-Shirt - Yugoslav Expression of Indifference - Born in Yugoslavia Heritage Apparel',
    name: '"Boli Me Kurac" T-Shirt - Philosophy of Indifference',
    description: 'The ultimate Yugoslav expression of not caring - now on a premium t-shirt',
    longDescription: 'Document YU-005 presents the quintessential Yugoslav philosophy in wearable form. "Boli Me Kurac" represents the transcendent state of not caring that Yugoslavs perfected over generations. This expression isn\'t anger—it\'s liberation from concern. Featuring bold typewriter typography in the authentic bureaucratic style, this t-shirt is a badge of cultural identity for those Born in Yugoslavia and anyone who appreciates the direct Balkan approach to life\'s minor inconveniences.',
    price: 26.99,
    currency: 'USD',
    availability: 'InStock',
    brand: 'Born in YU',
    sku: 'YU-005-TSHIRT',
    url: 'https://borninyu.com/product/boli-me-kurac-tshirt-yugoslav-expression',
    features: [
      'Iconic Yugoslav expression',
      'Authentic bureaucratic typography',
      'Premium 100% cotton fabric',
      'Conversation starter among Yugoslavs',
      'Unisex fit',
      'Cultural heritage statement',
    ],
    materials: ['100% Premium Cotton', 'Screen-printed design', 'Tag-free comfort label'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: '6',
    slug: 'jebiga-tshirt-yugoslav-philosophy',
    docNo: 'YU-006',
    classification: 'tshirt',
    cost: 'products.visitStore',
    imageUrl: '/products/jebiga-tshirt-yugoslav-philosophy.jpg',
    imageAlt: 'Jebiga T-Shirt - The One-Word Yugoslav Philosophy - Born in Yugoslavia Heritage Apparel',
    name: '"Jebiga" T-Shirt - The One-Word Philosophy',
    description: 'The most versatile word in the Yugoslav vocabulary - a complete philosophy in one expression',
    longDescription: 'Document YU-006 captures the entire Yugoslav worldview in a single word. "Jebiga" is resignation, acceptance, apology, and philosophy rolled into one. It\'s the response to everything from minor inconveniences to major life events. This premium t-shirt features the word in bold bureaucratic typography, celebrating the pragmatic Balkan approach to adversity. For those Born in Yugoslavia, it\'s instant recognition. For everyone else, it\'s a mystery worth explaining.',
    price: 26.99,
    currency: 'USD',
    availability: 'InStock',
    brand: 'Born in YU',
    sku: 'YU-006-TSHIRT',
    url: 'https://borninyu.com/product/jebiga-tshirt-yugoslav-philosophy',
    features: [
      'The ultimate Yugoslav philosophy',
      'Bold typewriter typography',
      'Premium 100% cotton',
      'Universal life philosophy',
      'Unisex fit',
      'Instant Yugoslav connection',
    ],
    materials: ['100% Premium Cotton', 'Screen-printed design', 'Tag-free comfort label'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: '7',
    slug: 'koji-kurac-mug-yugoslav-morning',
    docNo: 'YU-007',
    classification: 'mug',
    cost: 'products.visitStore',
    imageUrl: '/products/koji-kurac-mug-yugoslav-morning.jpg',
    imageAlt: 'Koji Kurac Coffee Mug - Yugoslav Morning Expression - Born in Yugoslavia Heritage',
    name: '"Koji Kurac?" Mug - Morning Philosophy',
    description: 'Start your day the Yugoslav way - with the perfect expression of morning confusion',
    longDescription: 'Document YU-007 answers the eternal morning question. "Koji kurac?" (What the...?) is the natural response to alarm clocks, Monday mornings, and unexpected situations. This ceramic mug features the phrase in classic bureaucratic typography, making it the perfect vessel for your morning coffee or rakija. A conversation piece for the office (if your colleagues are Yugoslav) or home.',
    price: 11.99,
    currency: 'USD',
    availability: 'InStock',
    brand: 'Born in YU',
    sku: 'YU-007-MUG',
    url: 'https://borninyu.com/product/koji-kurac-mug-yugoslav-morning',
    features: [
      'Classic Yugoslav morning greeting',
      'Bureaucratic typography design',
      'Premium ceramic construction',
      '11oz capacity',
      'Dishwasher and microwave safe',
      'Perfect for coffee or rakija',
    ],
    materials: ['Premium ceramic', 'Fade-resistant print', 'Glossy finish'],
    sizes: ['11oz Standard'],
  },
  {
    id: '8',
    slug: 'born-in-yugoslavia-tshirt-retro-synthwave',
    docNo: 'YU-008',
    classification: 'tshirt',
    cost: 'products.visitStore',
    imageUrl: '/products/Born_In_Yugoslavia_T-shirt.png',
    imageAlt: 'Born in Yugoslavia T-Shirt - Retro Synthwave Design with Neon Sunset and Star Emblem - Yugoslav Nostalgia Apparel',
    name: 'Born in Yugoslavia T-Shirt - Retro Synthwave',
    description: 'Yugowave aesthetic tee featuring neon sunset, star emblem and retro station wagon - evoking late-night drives and memories of home',
    longDescription: 'Document YU-008 carries a vivid, nostalgic scene—neon sunset, a star emblem and a retro station wagon—evoking late-night drives and memories of home. This Yugowave design blends Yugoslav nostalgia with synthwave aesthetics. The soft, broken-in hand from post-construction dyeing makes the colors sit gently on the fabric while the relaxed fit and durable double-needle seams let you wear it often without worry. It layers easily under jackets or wears solo on warm evenings, blending vintage Yugowave vibes with everyday comfort for anyone who remembers or reveres that past. The tubular knit keeps the silhouette clean and simple.',
    price: 26.22,
    currency: 'USD',
    availability: 'InStock',
    brand: 'Born in YU',
    sku: 'YU-008-TSHIRT',
    url: 'https://borninyu.com/product/born-in-yugoslavia-tshirt-retro-synthwave',
    features: [
      'Yugowave aesthetic design',
      'Heavyweight garment-dyed cotton',
      'Soft broken-in feel',
      'Neon sunset and star emblem design',
      'Retro station wagon graphic',
      'Relaxed fit',
      'Double-needle seams for durability',
      'Tubular knit construction',
    ],
    materials: ['100% Heavyweight Cotton', 'Garment-dyed', 'Double-needle construction'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'],
  },
];

export const getProductById = (id: string): Product | undefined => {
  return PRODUCTS.find((product) => product.id === id);
};

export const getProductBySlug = (slug: string): Product | undefined => {
  return PRODUCTS.find((product) => product.slug === slug);
};

export const getProductByDocNo = (docNo: string): Product | undefined => {
  return PRODUCTS.find((product) => product.docNo === docNo);
};
